import { Typography } from '@mui/material';

export const MissingFeatures = ({ missingFeature }) => {
  return (
    <>
      <Typography>{missingFeature}</Typography>
    </>
  );
};
